import React, { useState } from 'react';

import NameRow from '@rover/components/src/cards/SearchResultCard/InfoColumn/NameRow';
import { Flex, Text } from '@rover/kibble/core';
import type { TrainerSearchResultFlair } from '@rover/rsdk/src/apiClient/latest/model/trainerSearchResultFlair';

import TruncatedText from '../../../components/TruncatedText';
import VirtualOnlyBadge from '../../../components/VirtualOnlyBadge';

interface TrainerInfoColumnProps {
  displayExpanded: boolean;
  index?: number;
  city: string;
  state: string;
  shortName: string;
  title: string;
  virtualOnly: boolean;
  flair?: TrainerSearchResultFlair;
}
const TrainerInfoColumn = ({
  displayExpanded,
  index,
  city,
  state,
  shortName,
  title,
  virtualOnly,
  flair,
}: TrainerInfoColumnProps): JSX.Element => {
  const [isBadgeOpen, setIsBadgeOpen] = useState(false);

  const serviceLocation = [city, state].filter(Boolean).join(', ');

  const handleBadgeChange = (): void => {
    setIsBadgeOpen(true);
  };

  return (
    <Flex flex="1 1 0" flexDirection="column" px="4x">
      <NameRow
        badgeData={[]}
        displayExpanded={displayExpanded}
        name={shortName}
        handleBadgeChange={handleBadgeChange}
        index={index}
        isBadgeOpen={isBadgeOpen}
        flair={flair}
      />
      <TruncatedText size="100" mb="1x">
        {title}
      </TruncatedText>
      {virtualOnly ? (
        <VirtualOnlyBadge fontSize="100" />
      ) : (
        <Text size="100">{serviceLocation}</Text>
      )}
    </Flex>
  );
};

export default TrainerInfoColumn;
